import React from 'react';
import { getTranslation } from 'common/react/utils/translations';
import PropTypes from 'prop-types';

export const MobileResetButton = ({ resetToDefaults }) => (
    <div className="stats-leaders-nav__item-wrapper--reset">
        <button
            className="stats-leaders-filter-reset-button"
            onClick={resetToDefaults}
        >
            {getTranslation('label.statsLeaders.filters.resetButtonText')}
        </button>
    </div>
);

MobileResetButton.propTypes = {
    resetToDefaults: PropTypes.func.isRequired
};
